import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import Bank from '../components/banks/Bank';
import CreateBank from '../components/banks/CreateBank';
import EditBank from '../components/banks/EditBank';
import { ProtectedRoute } from '../helpers/ProtectedRoute';

const BanksRoutes = ({ match: { url } }) => 
  <Switch>
    <Route path={`${url}`} exact component={Bank} />
    <Route path={`${url}/:id`} exact component={Bank} />
    <ProtectedRoute path={`${url}/search/:all`} rols={['manager']} component={Bank} />
    <ProtectedRoute path={`${url}/create/:id`} rols={['manager']} component={CreateBank} />
    <ProtectedRoute path={`${url}/edit/:id`} rols={['manager']} component={EditBank} />
    <Redirect to="/errors/404" />
  </Switch>

BanksRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(BanksRoutes);